import { getAdminRoutePermission } from '../../adminRoutes';

const editLink = getAdminRoutePermission((x) => x.settingsUserPermissions);

export const permissionsListPermissions = {
    editLink,
};
